import {Pipe, PipeTransform} from '@angular/core';
import {OptTaskDetails} from '../classes/models/admin/OptTaskDetails';

/**
 * This pipe handles filtering a list of optimisation task details.
 */
@Pipe({
  name: 'optTaskFilter',
  pure: false,
})
export class OptTaskFilterPipe implements PipeTransform {

  /**
   * Filters store name and status of optimisation task details by the given search text.
   * @param items a list of optimisation task details.
   * @param search search text by which the results should be filtered.
   */
  transform(items: OptTaskDetails[], search: string): OptTaskDetails[] {
    if (!items) {
      return [];
    }
    if (!search) {
      return items;
    }

    search = search.toLowerCase();
    return items.filter(item => item.storeId.toLowerCase().includes(search) ||
            item.storeName.toLowerCase().includes(search) ||
            item.status.toLowerCase().includes(search));
  }
}
